import { useState, useEffect } from 'react';
import {getDynamicFormConfig} from "../../../../services/DynamicFormService";

const useDynamicForm = (dynamicFormStructureId) => {
    const [dynamicForm, setDynamicForm] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (dynamicFormStructureId) {
            setLoading(true);
            setError(null);
            getDynamicFormConfig(dynamicFormStructureId)
                .then(data => setDynamicForm(data.config || []))
                .catch(error => setError(error.message))
                .finally(() => setLoading(false));
        }
    }, [dynamicFormStructureId]);

    return { dynamicForm, loading, error };
};

export default useDynamicForm;
